import Link from "next/link";
import { storyLabel, type CaseStudy } from "@/data/caseStudies";

export default function CaseStudyCard({ story }: { story: CaseStudy }) {
  return (
    <Link
      href={`/case-studies/${story.slug}`}
      className="group flex h-full flex-col overflow-hidden rounded-2xl border border-[#54169C]/10 bg-white shadow-sm transition hover:-translate-y-0.5 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#54169C]"
    >
      <div className="relative aspect-square overflow-hidden bg-[#FDECF5]">
        <img
          src={story.poster}
          alt=""
          width={480}
          height={480}
          className="h-full w-full object-cover"
        />
        <span className="absolute inset-0 flex items-center justify-center bg-black/10 transition group-hover:bg-black/25">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-white text-[#DA159B] shadow-md">
            <svg viewBox="0 0 24 24" className="ml-0.5 h-6 w-6" fill="currentColor" aria-hidden="true">
              <path d="M8 5.14v13.72a1 1 0 0 0 1.53.85l10.2-6.86a1 1 0 0 0 0-1.7L9.53 4.29A1 1 0 0 0 8 5.14z" />
            </svg>
          </span>
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-5">
        {story.service ? <p className="text-sm font-medium text-[#DA159B]">{story.service}</p> : null}
        <h2 className="text-xl text-gray-900">
          {story.childFirstName ?? storyLabel(story)}
          {story.ageAtStart ? (
            <span className="font-normal text-gray-500"> · {story.ageAtStart}</span>
          ) : null}
        </h2>
        <p className="text-gray-600">{story.summary}</p>
      </div>
    </Link>
  );
}
